 <template>
    <article>

     <div class="top-section">
    <h1>Life After BOB</h1>
    <b>The Chalice Study</b><br><br>
    2021-2022<br><br>
    <i>What if AI could do the job of living your life better than you?</i>
    <div class="center-imgs">

    <div>
    <img class="bob-img" id="news-image" src="https://d2w9rnfcy7mm78.cloudfront.net/13008296/original_9d4945d75349d6589f7c0be2fbf28ee0.jpg" />
    </div>
    <div>
     <img class="bob-img" id="news-image" src="https://d2w9rnfcy7mm78.cloudfront.net/13008282/original_692454de84327ee68b1c0985804508f2.jpg" />
   </div>
 </div>
 </div>

   <div class="synopsis">
      <h3>Synopsis</h3>
      <p class="big-text">
Life After BOB is a 50min anime movie built in the Unity game engine.
      </p>
      <p class="indent-text">
        Life After BOB (LAB) imagines a future world in which the internet extends into our nervous system, psychotropic foods unify physical and psychic realities, AI entities are permitted to co-inhabit human minds, and anomie reigns. <br><br>
        In episode one ~ The Chalice Study ~ neural engineer Dr. Wong has installed an experimental AI named BOB (“Bag of Beliefs”) into the nervous system of his 10-year-old daughter Chalice. Designed to guide Chalice through the challenges of growing up in a volatile world, BOB confronts more and more of the conflicts in Chalice’s life on her behalf. As Dr. Wong begins to favor the BOB side of his daughter, and as BOB threatens to do the job of living Chalice’s life better than she can, Chalice wonders: what is left for her classic human self to do?
        <br><br>
        LAB has been presented live in real-time, featuring an interactive <i>WORLDWATCHING</i> mode for viewers to dive into any moment of the movie and explore the world and lore of LAB. Watch a rendered version of LAB below (subtitles in English, French, Spanish, German, Chinese, Korean).
       <!--  <br><br>
       Life After BOB features a revolutionary interactive way to explore the world of the movie called WORLDWATCHING. Use your smartphone as a personal remote to pause any scene and tap on any character, artifact, or entity in the frame to investigate its lore and mythology. -->
       <br><br>
       Official launch site <a href="https://lifeafterbob.io" target=blank>lifeafterbob.io</a>

        </p>
<p class="big-text">
</p>
  </div>
<section class="cinema-section">
<iframe width="846" height="362" src="https://www.youtube.com/embed/y8o-gtpLf5A?si=KHXep5ht3aDJN92H" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
</section>

  <!--
    <div class="top-section">
  <iframe width="846" height="360" src="https://www.youtube.com/embed/vCc2djR25hg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</div>
  -->

   <section class="padding-text">
      <h3>Exhibition History</h3>
        <ul v-if="emissaryExhibits" >
          <li v-for="(xbt, index) in emissaryExhibits" :key="xbt.id" >

            <a v-if="index < 100" :href="xbt['Website']" target="_blank" rel="nofollow">
              <span v-html="getYear(xbt['Opening Date'])"></span>&nbsp;
              {{xbt.Venue}} ~ <i>{{xbt['Show Title']}}</i> ~ {{xbt.City.split(',')[0]}}
            </a>

          </li>
        </ul>
</section>

<section class="padding-text">
<h3>Press & Interviews on LAB</h3>
  <ul v-if="emissaryPressClips" >
          <li v-for="(emPr, index) in emissaryPressClips" :key="emPr.id" >

               <a v-if="index < 20" :href="emPr['Link']" target="_blank" rel="nofollow">
                <span v-html="getYear(emPr['Date'])"></span>&nbsp;
              {{emPr['Publication']}}, <i>{{emPr['Title']}}</i>, by {{emPr['Author']}}
              </a>

          </li>
        </ul>
</section>

<section class="worldwatching-section">
<h3>Worldwatching Mode </h3>
<iframe width="846" height="360" src="https://www.youtube.com/embed/EYCy2syyVds?si=qV_kB9vuK24JD3f5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
</section>

<section>
  <h3 class="padding-text">Images</h3>
  <viewer channelSlug = 'lab-web-images' />
</section>

<div class="synopsis">
<h3>Production Credits</h3>
 <p>

Written & Directed by: Ian Cheng ~
Produced by: Veronica So ~
Technical Producer: Ivaylo Getov ~
Animation Producer: Nick Sung ~
Director of Photography: Eric Yue ~
Editor: Jess Fulton ~
Animation Supervisor: Valerie Scheiber ~
Sound Design: Akritchalerm Kalayanamitr ~
Music by: Brian Reitzell</p>

<p><b>Voice Performances</b><br>

Chalice Wong, BOB: Poonam Basu ~ Chalice (20), Chyna: Cherami Leigh ~
Dr. James Moonweed Wong: Dana Lee ~ Chairman Ava: Gwendoline Yeo ~
Zoroaster: Sean Patton ~ Orlando de Blair, Commander Alan: Aly Mawji ~
Princess Wendy (voice of ZIM): Jennifer Swanner ~ Sister San: Poonam Basu ~
ZIM Engineers: Ivaylo Getov ~ Humanistas: Jennifer Swanner, Gensho Tasaka</p>

<p><b>Animation</b><br>

Lead Animation: Paul Wood, Corey Stisser, Jenna Jaillet ~ Mocap Editor
& Layout: David Peng ~ Additional Animation: Lauren Assadofsky, Craig
Maras, Rob Somers, David Cohen ~ Movement Design & Choreography:
Madeline Hollander ~ Mocap Performance: Caroline Bloom ~ Facial Mocap
Performance: Ivaylo Getov, Veronica So ~ Character Rigging:
Chris Nelder ~ Mocap & Maya Pipeline: Twisted Mountain Animation,
Kerie Green, Fraser Sunderland
</p>
<p><b>Art Department</b><br>

Production Design: Elle Michalka, James Noellert ~ Character Design:
Alice Lemma, Sophie Li ~ Lead Concept Artist: Linnea Sterte ~ Additional
Concept Design: Jonathan Djob Nkondo, James Paterson, Jay Quercia, Alvin
Fai, Eran Hilleli ~ Character Modeling: Maritza Louis ~ Lead Environment
Artist: Shuruq Tramontini Additional 3D Modeling: Caco Peguero, Shanaz
Byrne, Breht O’Hearn, Travis Ragsdale ~ Title and Poster Design: Vasilis
Marmatakis ~ ZIM Corporate Design: Kenneth Cheng
</p>
<p><b>Story Department</b><br>

Head of Story: Nick Sung ~ Story Artist: Kallen Chi ~
Story Consultants: Anthony Weintraub, Adam Thirlwell
</p>
<p><b>Unity Real-time Cinematics Development</b><br>

Technical Director: Ivaylo Getov ~ Lead Unity Artist: Shuruq Tramontini ~
Technical Supervisor: Corbin Ordel ~ Graphics Developer: Nicholas Shelton ~
Developers: Samuel Eng, Yang Wang ~ VFX Designer: Sam Loeschen ~
VFX Artist: Ryan Zeng ~ Additional VFX: Rui An ~ Crowd Animation:
Corey Stisser ~ Procedural Wardrobe Stylist: Veronica So ~ Unity Tools Developer:
Cezar Mocan
</p>
<p><b>Unity Interactive Development</b><br>

Interactive Design: FLOAT ~ Wiki Developer: Alden Rivendale Jones ~ World Watching Developer:
Oren Shoham World Watching Artist: Shuruq Tramontini ~ UX Artist: Samuel Eng ~ UX Developer:
Cezar Mocan ~ Additional Wiki
Design: Sixing Xu ~ Interactive Assistant
Pei Barth Wu
</p>
<p><b>Sound Department</b><br>

Re-recording Mix: Akritchalerm Kalayanamitr ~ Surround Mastering Mix:
Michael Barry ~ Sound Assistant: Jiho Kim ~ ADR Engineering: Ivaylo Getov ~
Additional ADR Engineering: Matt Mehlan, Tyler Swanner, Nick Chirumbolo
~ Sound Post Production Supervisor: Traithep Wongpaiboon ~ Foley Recordists: Jirapong Mingkwan, Narongsak
Deetae ~ Foley Artists: Thanasak Julakate, Supawit Bhovijitra, Narongsak
Deetae, Amornpong Thokaeonopparat ~ Foley Editors: Chalida
Buranabunpot, Nusorn Thongkhum, Napatz Singkarat ~ Foley Production
Coordinators: Veerin Kongsuwan, Aoun Patiporn, Chatlada Saijaioub ~
Score Mixer: Kenneth Sluiter ~ String Arrangements: Roger Joseph Manning Jr. ~
Guitar: Dave Harrington ~ Vocals: Hazel Reitzell ~ Instrument Builder: Chris Banta
</p>
<p><b>Additional Production</b><br>

Associate Producer: Kyrha Lever ~
Production Advisor: Laura Lupton ~
Additional Production: Metis Suns LLC
</p>
<p><b>Co-Commissioned By</b><br>
The Shed, New York  ~
Luma Foundation, Arles  ~
Light Art Space, Berlin  ~

Additional Support by Leeum Museum of Art, Seoul  ~
Research developed with Berggruen Institute, The Transformations of The Human  ~
Production developed with Gladstone Gallery, New York & Pilar Corrias Gallery, London

</p>
<p><b>Thanks</b><br>

Barbara Gladstone, Pilar Corrias, Emma Enderby, Hans Ulrich Obrist, Alessandra Gomez, Alex Poots, Maja Hoffmann, Vassilis Oikonomopoulos, Luz Gyalui, Amira Gad, Liz Stumpf, Bettina Kames, Gina Lee, Nicolas Berggruen, Tobias Rees, Alissa Bennett, Marie Krauss, Ben Vickers, Venkatesh Rao, Sean Manning, Ron Martin, Steve Zapata, Amelia Rose Blaire, Bryan Dechart, Dean Panaro, David Kaplan, Lucie Elwes, Matthew Rogers, Tina Rogers, John So, Jenny Wong, Diana Rose, Jonathan Rose, Kenneth Cheng, Chukyee Cheng, Rachel Rose

</p>
<p><b>Welcome To This Life</b><br>

Eden Rose Cheng, Daphne Noellert, Matilda Steely-Getov, James Jaillet, Jovian Rogers, Milo Mecca, Silas Rose Cheng

</p>
</div>

 <section>
<h3 class="padding-text">Production Drawings</h3>
  <viewer channelSlug = 'lab-digital-drawings-nfts' />
  <viewer channelSlug = 'lab-drawings' />
</section>

 <section>
  <div class="synopsis">
  <h3>LAB First Tract</h3>
  <p>LAB began as a 16 page comic published in limited edition in 2019. It served as the inspiration for ideating the world of LAB and writing The Chalice Study.
  </p>

  <viewer channelSlug = 'lab-manga' />
  </div>
</section>

  </article>

</template>

<script>
// import Viewer from '@/views/Viewer.vue'
import Viewer from '@/views/Viewer.vue'

import { mapState, mapActions } from 'vuex' // imports from our Store
export default {
  name: 'Emissaries',
  components: { Viewer },
  computed: {
    // Store data imported from /src/store.js
    ...mapState(['exhibitions', 'bibliography', 'press']),
    emissaryExhibits () {
      return this.filterXbts2('LAB')
    },
    emissaryPressClips () {
      return this.filterEmissaryPress('LAB')
    },
    solo () {
      return this.filterXbts('Solo Exhibition')
    },
    group () {
      return this.filterXbts('Group Exhibition')
    },
    events () {
      return this.filterXbts('Events')
    },
    texts () {
      if (!this.bibliography || !this.press) return null
      const list = [...this.bibliography, ...this.press] // ES6
      return list.sort(this.sortDescByKey('Date'))
    }
  },
  methods: {
    // Actions from Store
    ...mapActions(['getExhibitions', 'getBibliography', 'getPress']),

    getRecords () {
      // Get records if don't exist already
      if (!this.exhibitions) this.getExhibitions()
      if (!this.bibliography) this.getBibliography()
      if (!this.press) this.getPress()
    },
    sortDescByKey (key) {
      return (a, b) => new Date(b[key]) - new Date(a[key])
    },
    filterXbts (type) {
      // const xbtsugh = this.$store.state.exhibitions
      // if (!xbtsugh) xbtsugh = []
      if (!this.exhibitions) return []
      const xbts = this.exhibitions.filter(rec => rec['Type of Exhibition'] === type)
      return xbts // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    filterXbts2 (type) {
      if (!this.exhibitions) return []
      const xbts2 = this.exhibitions.filter(rec => rec['Project Focus'] === type)
      return xbts2 // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    filterEmissaryPress (type) {
      // const pressugh = this.getPress()
      // if(!pressugh) pressugh = []
      if (!this.press) return []
      const emPress = this.press.filter(rec => rec['Project Focus'] === type)
      return emPress // xbts.sort(this.sortDescByKey('Opening Date'))
    },
    getYear: date => { date = new Date(date); return date.getFullYear() }
  },
  created () {
    this.getRecords()
  }
}
</script>

<style scoped>

.ep-column{
  display:block;
  width: 30%;
  float:left;
  margin-left: 10px;
  margin-right: 10px;
}
.top-section{
  float:left;
  clear:both;
  width: 100%;
  font-size: 1em;
  border-bottom: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}

.cinema-section{
  float:left;
  clear:both;
  width: 100%;
  font-size: 1em;
  border-bottom: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 18px;
  background-color: black;
}

.worldwatching-section{
  float:left;
  clear:both;
  font-size: 1em;
  border-bottom: 1px solid #ddd;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 18px;

}

.big-text{
  font-size: 1.25em;
}

.indent-text{
  font-size: 1em;
  border-radius: 7px;
  padding: 12px;
      border: 1.2px solid rgb(204, 204, 204);
      box-shadow: 3px 3px 8px #ddd;

}

.synopsis{
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 20px;
  clear:both;

}

section{
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  clear:both;
}

ul{
  padding-left: 2.5em;
  text-indent:-2.5em;
  width: 100%;
}

.padding-text{
  padding: 20px;
}

h1{
  text-align:center;
  font-size: 2em;
}

h3{
  text-align:left;
  font-size: 1em;
  margin-bottom: 10px;
}

li{
  line-height: 1.2em;
}

#news-image{
  width: 50%;
 float: left;
  margin: auto;
   display: block;
  border: solid 2px #ddd;
  margin-bottom: 20px;
  margin-top: 20px;
}
.center-imgs{
  float:center;
  display:block;

}
</style>
